/*
  Version: 1.0
  Author: Rock Solid Digital

  Usage:
  // $(element) should be an input text field
  $(element).rsdAutocomplete({
    minimumInputLength = 3,
    // minimum number of characters in input before autocomplete fires
    data = {
      'Hotels': [
        'Rydges North Sydney',
        'Rydges Sydney Airport',
        'Rydges Sydney Central',
        'QT Sydney',
        'Atura Sydney',
      ],
      'Locations': [
        'Sydney, NSW',
        'Sydney Airport, NSW',
        'Sydney CBD & Inner, NSW',
        'Sydney South, NSW',
        'Sydney West, NSW',
      ],

      // autocomplete output (pass in data object with this structure) each obj array = 1 column of filterable list
    },
    layout: 1,
    // still a TODO for usage. will be adding different autocomplete layouts for different screens.
    // - layout for booking widget on pages i.e. search, home, and offer page (layout 1).
    // - global search autocomplete layout (has parent column of hotels rydges, qt, etc. and city area)
    // - mobile global search (have dropdowns for filters)
  });
*/

(function($) {
  function AutoComplete(self, options) {
    const divConstants = {
      CONTAINER_CLASS: 'rsd-ac-container',
      LIST_CONTAINER_CLASS: 'rsd-ac-list',
      GROUP_CLASS: 'rsd-ac-group',
      ELEMENT_ID: 'rsd-ac-',
    };
    const HOTEL_SEARCH_ORDER_LIST = ['qt', 'rydges', 'atura', 'indcoll', 'lylo', ''];

    self.$element = $(self);
    // Check if element has unique rsd-ac- id
    if (self.$element.attr('id') === undefined || self.$element.attr('id').length <= 0) {
      let randomId = '';
      do {
        randomId = divConstants.ELEMENT_ID + Math.floor(Math.random() * 10000);
      }
      while ($('#' + randomId).length !== 0);

      // Add unique rsd-ac- id
      self.$element.attr('id', randomId);
    }

    self.$container = '';

    createContainer();

    self.$container = $('#' + 'container-' + self.$element.attr('id'));

    bindAllEvents();

    function createContainer() {
      const $autocompleteContainer = $('<div>').addClass(`${divConstants.CONTAINER_CLASS} layout-${options.layout}`);
      const containerId = 'container-' + self.$element.attr('id');
      $autocompleteContainer.attr('id', containerId);

      // Build up the list
      $autocompleteContainer.append(buildList(''));

      // append autocomplete container
      if (options.container !== null) {
        $autocompleteContainer.addClass('in-container');
        options.container.append($autocompleteContainer);
      } else {
        // Default show/hide events
        $autocompleteContainer.on('show.rsd-ac', function() {
          $(this).fadeIn('fast');
        }).on('hide.rsd-ac', function() {
          $(this).fadeOut('fast');
        });

        self.$element.after($autocompleteContainer);
      }
    }

    function buildList(inputPhrase) {
      const $listContainer = $('<div>').addClass(divConstants.LIST_CONTAINER_CLASS);
      const useDefaultSearchKey = inputPhrase.length === 0 && null !== options.defaultSearchKeyOnEmpty;

      if (inputPhrase.length > options.minimumInputLength || useDefaultSearchKey) {
        Object.entries(options.data).forEach((entry) => {
          const listName = entry[0];
          let listValues = entry[1];

          if (listName === 'Hotels' && listValues.length > 1) {
            listValues = listValues.sort((a, b) => {
              return HOTEL_SEARCH_ORDER_LIST.indexOf(a.brand) - HOTEL_SEARCH_ORDER_LIST.indexOf(b.brand);
            })
          }

          const $listGroup = $('<div>').addClass(divConstants.GROUP_CLASS);
          const $listName = $('<div>').addClass('list-name').html(listName);
          const $listList = $('<div>').addClass('list-list');

          if (useDefaultSearchKey && (listName in options.defaultSearchKeyOnEmpty)) {
            inputPhrase = options.defaultSearchKeyOnEmpty[listName];
          }

          for (let i = 0; i < listValues.length; i++) {
            const inputLowerCase = inputPhrase.toLowerCase();

            if (typeof listValues[i] === 'object') {
              const valueLowerCase = listValues[i].name.toLowerCase();
              const valueMatchName = valueLowerCase.indexOf(inputLowerCase) !== -1;
              let valueMatchKeyword = false;
              let valueMatchEmptyKeywords = false;

              if ('keywords' in listValues[i] && listValues[i].keywords) {
                const keywords = listValues[i].keywords.split(/,\s*/);

                for (let j = 0; j < keywords.length; j++) {
                  if (keywords[j].toLowerCase().indexOf(inputLowerCase) >= 0) {
                    valueMatchKeyword = true;
                    break;
                  }
                }
              }

              if (useDefaultSearchKey && 'empty_keywords' in listValues[i] && listValues[i]['empty_keywords']) {
                const emptyKeywords = listValues[i]['empty_keywords'].split(/,\s*/);

                for (let j = 0; j < emptyKeywords.length; j++) {
                  if (emptyKeywords[j].toLowerCase().indexOf(inputLowerCase) >= 0) {
                    valueMatchEmptyKeywords = true;
                    break;
                  }
                }
              }

              if (valueMatchName || valueMatchKeyword || valueMatchEmptyKeywords || inputPhrase === '' || self.$element.prop('readonly')) {
                const value = listValues[i].name;
                let itemTag = '<p>';
                let extraTags = '';

                if ('is_new' in listValues[i] && listValues[i]['is_new']) {
                  extraTags = '<span class="item-tag">new</span>';
                }

                if ('attribs' in listValues[i] && listValues[i]['attribs'].length > 0) {
                  itemTag = `<p ${listValues[i]['attribs']}>`;
                }

                let $listItem = $(`${itemTag}`).html(value + extraTags);

                $listItem.on('click', listItemClick(value, $listItem.data()));

                if (
                  options.maxResults === -1 ||
                  $listList.children().length < options.maxResults
                ) {
                  $listList.append($listItem);
                }
              }
            } else {
              const valueLowerCase = listValues[i].toLowerCase();

              if (valueLowerCase.indexOf(inputLowerCase) !== -1 || inputPhrase === '' || self.$element.prop('readonly')) {
                const value = listValues[i];
                const $listItem = $('<p>').html(value);

                $listItem.on('click', listItemClick(value, $listItem.data()));

                if (
                  options.maxResults === -1 ||
                  $listList.children().length < options.maxResults
                ) {
                  $listList.append($listItem);
                }
              }
            }
          }

          if ($listList.is(':empty')) {
            const emptyString = 'No ' + listName.toLowerCase() + ' found.';
            const $listEmpty = $('<p>').addClass('no-entry').html(emptyString);
            $listList.append($listEmpty);
          }

          // Append list name to group
          if (options.showListName) {
            $listGroup.append($listName);
          }

          // Append group to list
          $listGroup.append($listList);

          // Append list to container
          $listContainer.append($listGroup);
        });

        if (inputPhrase === '' && options.extra.length) {
          $listContainer.append(
            $('<div>').addClass(`${divConstants.GROUP_CLASS} rsd-ac-extra`).append('<hr>')
          );
        }
      }

      // Placeholder extra section class
      if (inputPhrase === '' && options.extra.length) {
        $listContainer.append($('<div>').addClass(`${divConstants.GROUP_CLASS} rsd-ac-extra`).append(options.extra));
      }

      // Display none container if no content or extras
      if (
        !(inputPhrase.length > options.minimumInputLength) &&
        !(options.extra.length) &&
        null === options.defaultSearchKeyOnEmpty
      ) {
        $listContainer.css('display', 'none');
      }

      return $listContainer;
    }

    function listItemClick(value, metadata) {
      const selfElement = self.$element;

      return function() {
        selfElement.val(value);
        selfElement.trigger('input_changed.rsd-ac', [value, metadata]);
        loadData(value);
        if (null !== options.onSelectCallback && $.isFunction(options.onSelectCallback)) {
          options.onSelectCallback(value, metadata);
        }
      };
    }

    function loadData(inputPhrase) {
      // empty current list
      self.$container.empty();

      if (inputPhrase.length < options.minimumInputLength) {
        self.$container.append(buildList(''));
        return;
      }

      // build new list based on input phrase
      self.$container.append(buildList(inputPhrase));
    }

    function showContainer() {
      self.$container.trigger('show.rsd-ac');
    }

    function hideContainer() {
      self.$container.trigger('hide.rsd-ac');
    }

    function bindAllEvents() {
      self.$element.keyup(function(event) {
        switch (event.keyCode) {
          case 27:
            hideContainer();
            self.$element.blur();
            break;
          default:
            showContainer();
            loadData($(this).val());
            break;
        }
      });

      self.$element.on('focus click', function() {
        // Show container on focus
        showContainer();
      });

      self.$element.on('blur', function() {
        // Add delay to fire click events before hiding
        setTimeout(function() {
          // Hide container on blur
          hideContainer();
        }, 200);
      });
    }
  }

  $.fn.rsdAutocomplete = function(option) {
    return this.each(function() {
      const options = typeof option === 'object' && option;

      new AutoComplete(this, $.extend({
        minimumInputLength: 3,
        maxResults: 5,
        defaultSearchKeyOnEmpty: null,
        data: [],
        extra: '',
        layout: 1,
        container: null,
        showListName: true,
        onSelectCallback: null,
      }, options));
    });
  };

}(jQuery));



// WEBPACK FOOTER //
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/evt-core/lib/autocomplete/autocomplete.js